// メッセージ文言定義
export class MessageText {
    // #region --------[設定関連]--------

    // 設定確認メッセージ
    public static readonly settingApplyConfirmMessage = "設定を適用します。<br />よろしいですか？";
    public static readonly settingApplyConfirmMessage2 = "変更した内容を適用しますか？";
    public static readonly settingNotApplyConfirmMessage = "適用せずに終了してよろしいですか？";
    public static readonly settingApplyCompleteMessage = "設定の適用が完了しました。";
    public static readonly settingInvalidTitlesErrorMessage = "設定した内容に不正な項目が存在するため、適用できません。<br />以下の設定内容を確認してください。";
    public static readonly settingApplyConfirmMDMAppMessage = "SKYSEA MDMアプリ設定で「VPPアプリとしてインストールする」が選択されていますが、VPP設定が行われていません。<br />このまま設定を適用すると、VPPアプリとしての配布は行えません。<br /><br />変更した内容を適用してよろしいですか？";

    // 設定確認メッセージ
    public static readonly settingApplyErrorMessage = "設定の適用に失敗しました。";
    public static readonly settingGetErrorMessage = "設定の取得に失敗しました。";
    public static readonly settingConfirmOverwriteMessage = "未適用のデータは破棄されます。<br>よろしいですか？";

    // 設定不可能メッセージ
    public static readonly settingPrintCollectAppPathInvalid = "印刷アプリケーションのファイルパスを収集する場合は、「プリント」ログを端末上で収集する必要があります。<br /><br />「プリント - プリンターサーバーを経由する印刷のログ収集設定」を、\"印刷を行う端末上で収集する\"に設定してください。";
    public static readonly settingPrintCollectAppPathInvalid2 = "プリンターサーバー上でログの収集を行う場合は、以下の設定を行ってください。<br /><br />・「プリント - ログに追加する情報 - 印刷アプリケーションのファイルパス」のチェックを外してください。";

    // 部署設定用メッセージ
    public static readonly settingInheritedDivisionMessage = "すでに上位部署の設定を継承しています。";
    public static readonly settingInheritErrorByAnyFunctionDisabled = "一部の設定が制限されています。<br />上位部署から設定を継承することはできません。";
    public static readonly settingInheritErrorByNotViewable = "閲覧権限がない部署の設定を、下位の部署から継承することはできません。<br />この部署の継承設定は、上位部署が閲覧可能なユーザーから行ってください。";
    public static readonly settingApplyErrorByDivisionUpdated = "適用に失敗しました。<br /><br />部署情報が変更されています。<br />ページを更新して、最新の部署情報を取得してください。";
    public static readonly settingDeleteErrorByNotViewable = "閲覧権限がない部署に所属する端末のため、削除できません。";
    public static readonly settingInheritDivisionCoufirm = "以下の部署設定を継承して、「%s」部署の現在の設定をすべて更新します。<br />よろしいですか？<br /><br />継承元部署：%s";
    
    // データの取得に失敗
    public static readonly dataGetErrorMessage = "データの取得に失敗しました。";

    // #endregion --------[設定関連関連]--------

    // #region --------[インポート関連]--------

    // 資産インポート確認メッセージ
    public static readonly assetImportConfirmMessage =
        "指定ファイルのデータのインポートを行います。<br />" +
        "資産情報編集で編集可能な項目が反映されます。<br /><br / >" +
        "よろしいですか？";

    // CSVファイルインポート完了メッセージ
    public static readonly importCompleteMessage = "インポートが完了しました。";

    // CSVファイルインポート失敗メッセージ
    public static readonly importFailedMessage = "インポートに失敗しました。";

    // CSVファイルインポートワーニングーメッセージ(CSV ファイルのヘッダに「コンピューター名」がない)
    public static readonly importWarningMessage = "指定ファイルのデータに「コンピューター名」がありません。<br />コンピューター名が記載されているファイルを指定してください。";

    // CSVファイルインポート中止メッセージ
    public static readonly importCancelMessage = "インポートを中止しました。";

    // インポートするファイルが指定されていない
    public static readonly importFileIsNothing = "インポートするファイルを指定してください。";

    // インポートするファイルがサイズが1GBを超える
    public static readonly importFileOverSize = "選択したファイルのサイズが1GBを超えるため、インポートできません。<br /><br />ファイルのサイズが1GB以下になるように、複数ファイルに分けてインポートしてください。";

    // #endregion --------[インポート関連]--------

    // #region --------[クリップボード関連]--------

    // クリップボードにコピーした時のメッセージ
    public static readonly copyToClipboard = "クリップボードにコピーしました。";

    // クリップボードへのコピーに失敗
    public static readonly copyToClipboardIsFailed = "クリップボードへのコピーに失敗しました。";

    // #endregion --------[クリップボード関連]--------

    // #region --------[VPPライセンス管理]--------

    public static readonly vppSettingInvalid = "VPP連携が無効に変更されたため、VPPライセンス情報の取得に失敗しました。";

    public static readonly vppLicenseInfoGetError = "VPPライセンス情報の取得に失敗しました。";

    // #endregion --------[VPPライセンス管理]--------

    // #region --------[モバイル登録画面]--------

    public static readonly mobileInfoGetError = "端末情報の取得に失敗しました。";

    public static readonly mobileRegisterInfoGetError = "モバイル端末登録に必要な情報の取得に失敗しました。";

    public static readonly mobileRegisterUpdateError = "モバイル端末仮登録に失敗しました。";

    public static readonly mobileRegisterlinkedProfileError = "端末の仮登録には成功しましたが、ADEプロファイルの適用に失敗しました。<br/><br/>ADEプロファイル未割り当ての状態でモバイル端末の初期設定を行った場合、SKYSEA Client Viewへの登録は行われません。<br/>ハードウェア一覧画面右側のメニュー（<i class=\"icon-font-in-text icon-menu\"></i>）の「モバイル端末登録（iOS） - ゼロタッチ登録（ADE） - ADEプロファイル管理」画面から、ADEプロファイルの割り当てを行ってください。"

    public static readonly mobileRegisterConfirmMessage = "モバイル端末の仮登録を行います。<br />よろしいですか？"

    public static readonly mobuleRegisterApnsCertUnregist = "Appleプッシュ通知証明書が登録されていないため、モバイル端末登録は行えません。<br />「設定 - モバイル設定 - iOS用設定 - 共通設定」でAppleプッシュ通知証明書を登録してください。"
    public static readonly mobuleRegisterApnsCertUnregistUnauthorized = "Appleプッシュ通知証明書が登録されていないため、モバイル端末登録は行えません。<br />システム管理者にお問い合わせください。"

    public static readonly mobileRegisterMDMSetverTokenUnregist = "ゼロタッチ登録設定が完了していないため、ゼロタッチ登録を利用したiOS端末の登録は行えません。<br />「設定 - モバイル設定 - iOS用設定 - 共通設定」でゼロタッチ登録設定を行ってください。"
    public static readonly mobileRegisterMDMSetverTokenUnregistUnauthorized = "ゼロタッチ登録設定が完了していないため、ゼロタッチ登録を利用したiOS端末の登録は行えません。<br />システム管理者にお問い合わせください。"

    public static readonly mobileUpdateSetting = "モバイル設定の更新を行いました。";
    public static readonly mobileUpdateSettingNeedMDMAndloid = "モバイル設定の更新を行いました。<br /><br />SKYSEA MDMアプリのインストールは、以下の画面から行ってください。<br />「アプリケーション一覧 - モバイル - Androidアプリ管理」"
    public static readonly mobileUpdateSettingNeedMDMAndloidUnauthorized = "モバイル設定の更新を行いました。<br /><br />SKYSEA MDMアプリのインストールは、Androidアプリ管理機能で設定が必要です。<br />システム管理者にご連絡ください。"
    public static readonly mobileUpdateSettingNeedMDMiOS = "モバイル設定の更新を行いました。<br /><br />SKYSEA MDMアプリのインストールは、以下の画面から行ってください。<br />「アプリケーション一覧 - モバイル - iOSアプリ管理 - アプリ配布」"
    public static readonly mobileUpdateSettingNeedMDMiOSUnauthorized = "モバイル設定の更新を行いました。<br /><br />SKYSEA MDMアプリのインストールは、アプリ配布機能で設定が必要です。<br />システム管理者にご連絡ください。"

    // #region --------[AndroidEnterprise関連]--------
    public static readonly mobileEnterpriseUnregisteredPolicy = "Android Enterpriseとの連携設定が完了していないため、MDMポリシーの設定は行えません。<br />「設定 - モバイル設定 - Android用設定 - 共通設定」でAndroid Enterprise連携設定を行ってください。";
    public static readonly mobileEnterpriseUnregisteredPolicyUnauthorized = "Android Enterpriseとの連携設定が完了していないため、MDMポリシーの設定は行えません。<br />システム管理者にお問い合わせください。";
    public static readonly mobileEnterpriseUnregisteredApp = "Android Enterpriseとの連携設定が完了していないため、アプリ管理の設定は行えません。<br />「設定 - モバイル設定 - Android用設定 - 共通設定」でAndroid Enterprise連携設定を行ってください。";
    public static readonly mobileEnterpriseUnregisteredAppUnauthorized = "Android Enterpriseとの連携設定が完了していないため、アプリ管理の設定は行えません。<br />システム管理者にお問い合わせください。";
    public static readonly mobileEnterpriseUnregistered = "Android Enterpriseとの連携設定が完了していないため、Android端末の登録は行えません。<br />「設定 - モバイル設定 - Android用設定 - 共通設定」でAndroid Enterprise連携設定を行ってください。";
    public static readonly mobileEnterpriseUnregisteredUnauthorized = "Android Enterpriseとの連携設定が完了していないため、Android端末の登録は行えません。<br />システム管理者にお問い合わせください。";
    public static readonly mobileEnterpriseUnregisteredSkysea = "Android Enterpriseとの連携設定が完了していないため、SKYSEA MDMアプリ認証コード確認は行えません。<br/>「設定 - モバイル設定 - Android用設定 - 共通設定」でAndroid Enterprise連携設定を行ってください。";
    public static readonly mobileEnterpriseUnregisteredSkyseaUnauthorized = "Android Enterpriseとの連携設定が完了していないため、SKYSEA MDMアプリ認証コード確認は行えません。<br/>システム管理者にお問い合わせください。";

    public static readonly mobileEnterpriseGetError = "Android Enterprise連携設定の取得に失敗しました。";

    public static readonly mobileEnterpriseRegistError = "連携設定の開始に失敗しました。";

    public static readonly mobileEnterpriseUnregistError = "連携設定の解除に失敗しました。";

    public static readonly mobileEnterpriseUnregisteredGetInfo = "Android Enterpriseとの連携設定が完了していないため、「モバイル端末機(Android)情報取得」は行えません。";

    public static readonly mobileEnterpriseUnregistSuccess = "連携設定の解除が完了しました。<br /><br />別途必要な操作があります。<br />詳細は製品マニュアルをご確認ください。";

    public static readonly mobileEnterpriseIgnoreLock = "Android Enterpriseとの連携設定が「未連携」のため、「端末ロック」は行えません。";

    public static readonly mobileEnterpriseIgnoreWipe = "Android Enterpriseとの連携設定が「未連携」のため、「端末内データ消去（ワイプ）」は行えません。";

    public static readonly mobileEnterpriseIgnorePass = "Android Enterpriseとの連携設定が「未連携」のため、「パスコード／パスワード消去」は行えません。";

    public static readonly mobileEnterpriseCreateDpcInfo = "Android Enterpriseとの連携設定が完了していないため、DPC補足情報は作成できません。<br />Android Enterprise連携設定を行ってください。";

    // #endregion --------[AndroidEnterprise関連]--------

    // #region --------[モバイル端末制御関連]--------
    public static readonly depDeviceWipeError = "ADEプロファイルの割り当て解除に失敗したため、端末内データ消去（ワイプ）を中止しました。";

    public static readonly mixedIOSandAndroidLock = "選択している端末に、モバイル端末（iOS）とモバイル端末（Android）が混在しています。<br />混在している状態では、端末ロックを利用できません。<br /><br />端末を選択し直してください。";
    public static readonly mixedIOSandAndroidWipe = "選択している端末に、モバイル端末（iOS）とモバイル端末（Android）が混在しています。<br />混在している状態では、端末内データ消去（ワイプ）を利用できません。<br /><br />端末を選択し直してください。";
    public static readonly mixedIOSandAndroidClearPasscode = "選択している端末に、モバイル端末（iOS）とモバイル端末（Android）が混在しています。<br />混在している状態では、パスコード／パスワード消去を利用できません。<br /><br />端末を選択し直してください。";
    public static readonly mixedIOSandAndroidEnableLostMode = "選択している端末に、モバイル端末（iOS）とモバイル端末（Android）が混在しています。<br />混在している状態では、紛失モード有効化を利用できません。<br /><br />端末を選択し直してください。";
    public static readonly mixedIOSandAndroidDisableLostMode = "選択している端末に、モバイル端末（iOS）とモバイル端末（Android）が混在しています。<br />混在している状態では、紛失モード解除を利用できません。<br /><br />端末を選択し直してください。";

    // #endregion --------モバイル端末制御関連]--------

    // #endregion --------[モバイル登録画面]--------

    // #region --------[DEPモバイル登録画面]--------

    public static readonly depMobileUpdateLastUpdate = "に取得した端末情報を表示しています。<br />最新の端末一覧が必要な場合は更新してください。";
    public static readonly depMobileUpdateProgressClose = "端末情報の取得処理が完了するまでは、端末の登録は行えません。<br/>「モバイル端末登録」画面を終了します。<br/><br/>しばらくしてから、「モバイル端末登録」画面を開き直してください。";

    public static readonly depMobileResisterProgressCloseMDMOn = "バックグラウンドでモバイル端末の仮登録処理を継続します。<br/><br/>モバイル端末の仮登録が完了すると、「ハードウェア一覧 - 端末一覧」に指定した台数の未登録の「モバイル端末（iOS）」が追加されます。<br/>しばらく待ってからページを更新して確認してください。<br/><br/>仮登録完了後に、以下の作業を行ってください。<br/>・モバイル端末を起動して初期設定を行ってください。本登録が行われます。<br/><br/>・SKYSEA MDMアプリの利用開始作業を行ってください。<br/>詳細は、ハードウェア一覧画面右側のメニュー（<i class=\"icon-font-in-text icon-menu\"></i>）の「モバイル端末登録（iOS） - SKYSEA MDMアプリ認証コード確認」で確認できます。";
    public static readonly depMobileResisterProgressCloseMDMOff = "バックグラウンドでモバイル端末の仮登録処理を継続します。<br/><br/>モバイル端末の仮登録が完了すると、「ハードウェア一覧 - 端末一覧」に指定した台数の未登録の「モバイル端末（iOS）」が追加されます。<br/>しばらく待ってからページを更新して確認してください。<br/><br/>仮登録完了後に、以下の作業を行ってください。<br/>・モバイル端末を起動して初期設定を行ってください。本登録が行われます。";

    public static readonly depMobileRegisterlinkErrorProcessExist = "端末の仮登録には成功しましたが、ADEプロファイルの適用に失敗しました。<br/>現在、Apple Business Managerへ設定を反映中のため、ADEプロファイルの適用は行えません。<br/><br/>ADEプロファイル未割り当ての状態でモバイル端末の初期設定を行った場合、SKYSEA Client Viewへの登録は行われません。<br/>ハードウェア一覧画面右側のメニュー（<i class=\"icon-font-in-text icon-menu\"></i>）の「モバイル端末登録（iOS） - ゼロタッチ登録（ADE） - ADEプロファイル管理」画面から、ADEプロファイルの割り当てを行ってください。"

    public static readonly depProcessExistRelayRequest = "現在、Apple Business Managerへ設定を反映中のため、実行できません。<br/>しばらくしてから、再度実行してください。";

    // #endregion --------[DEPモバイル登録画面]--------

    // #region --------[DEPプロファイル関連]--------
    public static readonly depProfileMngMDMSetverTokenUnregist = "ゼロタッチ登録設定が完了していないため、ADEプロファイル管理は行えません。<br />「設定 - モバイル設定 - iOS用設定 - 共通設定」でゼロタッチ登録設定を行ってください。"
    public static readonly depProfileMngMDMSetverTokenUnregistUnauthorized = "ゼロタッチ登録設定が完了していないため、ADEプロファイル管理は行えません。<br />システム管理者にお問い合わせください。"
    public static readonly depProfileMngInfoGetError = "ADEプロファイル管理に必要な情報の取得に失敗しました。";
    public static readonly depProfileDelError = "ADEプロファイルの削除に失敗しました。";
    public static readonly depProfileRegError = "ADEプロファイルの登録に失敗しました。";
    public static readonly depProfileApplyError = "ADEプロファイルの適用に失敗しました。";
    public static readonly depProfileResetError = "ADEプロファイルの割り当て解除に失敗しました。";
    public static readonly depLinkedError = "ADEプロファイルの割り当てに失敗しました。<br/><br/>※ADEプロファイル未割り当ての状態でモバイル端末の初期設定を行った場合、SKYSEA Client Viewへの登録は行われません。<br/>ADEプロファイル管理画面の端末一覧の「割り当て済みADEプロファイル名」列で、割り当て状況を確認してください。";

    public static readonly depProfileUpdateProgressClose = "端末情報の取得処理が完了するまでは、ADEプロファイルの設定／解除は行えません。<br/>「ADEプロファイル管理」画面を終了します。<br/><br/>しばらくしてから、「ADEプロファイル管理」画面を開き直してください。";
    public static readonly depProfileResetProgressClose = "ADEプロファイルの解除処理が完了するまでは、ADEプロファイルの設定や解除は行えません。<br/>「ADEプロファイル管理」画面を終了します。<br/><br/>しばらくしてから、「ADEプロファイル管理」画面を開き直してください。";
    public static readonly depProfileApplyProgressClose = "ADEプロファイルの適用処理が完了するまでは、ADEプロファイルの設定や解除は行えません。<br/>「ADEプロファイル管理」画面を終了します。<br/><br/>しばらくしてから、「ADEプロファイル管理」画面を開き直してください。";

    // #endregion --------[DEPプロファイル関連]--------

    // #region --------[構成プロファイル関連]--------

    public static readonly profileCommonSettingConfirmMessage = "設定方法を変更すると、現在の設定内容は破棄されます。<br/>変更してもよろしいですか？";

    // #endregion --------[構成プロファイル関連]--------

    // #region --------[デバイス管理画面]--------

    public static readonly deviceAlertOnlyDevWriteCannotEnableForMac =
        "Macに対して「記憶媒体書き込み」アラートのみを有効にすることはできません。<br />" +
        "「禁止」にチェックを入れて制限してください。";

    // #endregion --------[デバイス管理画面]--------

    // #region --------[ライセンス関連]--------

    public static readonly invalidLicense = "お使いのライセンスでは、本機能をご利用になれません。";

    // #endregion --------[ライセンス関連]--------

    // #region --------[MDM関連]--------

    public static readonly unregistedMDMServer = "紛失端末制御機能を利用するための処理が完了していません。<br />しばらく経ってから再度ログインして、もう一度実行してください。";
    public static readonly managedAppConfigErrorNoExistAgent = "適用対象の端末が存在しません。";

    public static readonly MDMDisabled = "紛失状態の直接解除が許可されていません。<br />以下の設定を有効にしてください。<br /><br />・「設定 - 紛失端末制御設定 - 共通設定 - 端末上で「紛失状態」の直接解除を許可する」"
    public static readonly MDMDisabledUnauthorized = "紛失状態の直接解除が許可されていません。<br />システム管理者にお問い合わせください。"

    public static readonly MDMDisabledLostDevice = "この機能をご利用になるには、システム管理者による機能の有効化が必要です。<br />システム管理者にご連絡ください。<br /><br />※システム管理者でログインして「重要なお知らせ」画面の[紛失端末制御機能の利用を開始する]ボタンを押すと、有効化できます。";

    public static readonly locationMobileDisabled = "この機能をご利用になるには、システム管理者による機能の有効化が必要です。<br />システム管理者にご連絡ください。<br /><br />※システム管理者でログインして[モバイル端末位置情報管理]ボタンを押すと、有効化できます。";
    // #endregion --------[MDM関連]--------

    // #region --------[多要素認証関連]--------

    // ワンタイムパスワード
    public static readonly oneTimePasswordErrorEmpty = "入力必須項目です。";
    public static readonly oneTimePasswordErrorIncorrect = "ワンタイムパスワードが正しくありません。";
    public static readonly oneTimePasswordErrorAuthentication = "ワンタイムパスワードの認証に失敗しました。";
    public static readonly oneTimePasswordErrorDispSetting = "設定画面の表示に失敗しました。";
    public static readonly oneTimePasswordErrorGetSetting = "設定の取得に失敗しました。";
    public static readonly oneTimePasswordErrorDispConfirm = "確認画面の表示に失敗しました。";

    // #endregion --------[多要素認証関連]--------

    // #region --------[ダッシュボード画面]--------
    public static readonly dashboardDisablePanelDetailHardware = "「ハードウェア一覧 - 端末一覧」が利用できないため、パネルの詳細情報を表示できません。";
    public static readonly dashboardDisablePanelDetailOS = "「アプリケーション一覧 - OS」が利用できないため、パネルの詳細情報を表示できません。";

    // #endregion --------[ダッシュボード画面]--------

    // #region --------[機能制限設定関連]--------

    public static readonly childAllApprovalMessage = "選択した機能に加えて、配下の機能をすべて許可にしますか？";
    public static readonly childAllApprovalLinkageeMDMSetToMDMSetWebMessage = "選択した機能に加えて、配下の機能をすべて許可にしますか？<br/><br/>※「紛失端末制御」を許可にすると、以下の機能も許可になります。<br/>・資産管理 - ハードウェア一覧 - 紛失端末制御状況";
    public static readonly linkageMDMSetWebToMDMSetApprovalMessage = "「紛失端末制御状況」を許可にすると、以下の機能も許可になります。<br/>よろしいですか？<br/><br/>・資産管理 - ハードウェア一覧 - 端末一覧 - 紛失端末制御";
    public static readonly linkageMDMSetWebToMDMSetDisapprovalMessage = "「紛失端末制御状況」を禁止にすると、以下の機能も禁止になります。<br/>よろしいですか？<br/><br/>・資産管理 - ハードウェア一覧 - 端末一覧 - 紛失端末制御";
    public static readonly linkageMDMSetToMDMSetWebApprovalMessage = "「紛失端末制御」を許可にすると、以下の機能も許可になります。<br/>よろしいですか？<br/><br/>・資産管理 - ハードウェア一覧 - 紛失端末制御状況";
    public static readonly linkageMDMSetToMDMSetWebApprovalMessageIndirectly = "選択した機能に加えて、配下の機能をすべて許可にしますか？<br/><br/>※「紛失端末制御」を許可にすると、以下の機能も許可になります。<br/>・資産管理 - ハードウェア一覧 - 紛失端末制御状況";
    public static readonly linkageMDMSetToMDMSetWebDisapprovalMessage = "「紛失端末制御」を禁止にすると、以下の機能も禁止になります。<br/>よろしいですか？<br/><br/>・資産管理 - ハードウェア一覧 - 紛失端末制御状況";
    public static readonly linkageMDMSetToMDMSetWebDisapprovalMessageIndirectly = "選択した機能に加えて、配下の機能をすべて禁止にします。<br/><br/>※「紛失端末制御」を禁止にすると、以下の機能も禁止になります。<br/>・資産管理 - ハードウェア一覧 - 紛失端末制御状況<br/><br/>よろしいですか？";
    public static readonly linkageCsvExpToLGBApprovalMessage = "「ログ一括出力」を許可にすると、以下の機能も許可になります。<br/>よろしいですか？<br/><br/>・ログ管理 - ログ閲覧";
    public static readonly linkageCsvExpToLGBApprovalMessageIndirectly = "選択した機能に加えて、配下の機能をすべて許可にします。<br/><br/>「ログ一括出力」を許可にすると、以下の機能も許可になります。<br/>・ログ管理 - ログ閲覧<br/><br/>よろしいですか？";
    public static readonly linkageLGBToCsvExpDisapprovalMessage = "「ログ閲覧」を禁止にすると、以下の機能も禁止になります。<br/>よろしいですか？<br/><br/>・設定 - ログ一括出力";
    public static readonly linkageLGBToCsvExpDisapprovalMessageIndirectlyParent = "選択した機能に加えて、配下の機能をすべて禁止にします。<br/><br/>※「ログ閲覧」を禁止にすると、以下の機能も禁止になります。<br/>・設定 - ログ一括出力<br/><br/>よろしいですか？";
    public static readonly linkageLGBToCsvExpDisapprovalMessageIndirectlyChild = "選択した機能に加えて、上位の機能も禁止にします。<br/><br/>※「ログ閲覧」を禁止にすると、以下の機能も禁止になります。<br/>・設定 - ログ一括出力<br/><br/>よろしいですか？";

    // #endregion --------[機能制限設定関連]--------

    // #region --------[共通]--------
    // import
    public static readonly CommonInputFailedEmpty = "入力必須項目です。";
    public static readonly CommonInputFailedRength = "%s文字以上%s文字以内で入力してください。";
    public static readonly CommonInputFailedControlCode = "制御コードは使用できません。";
    // #endregion --------[共通]--------
}
